var ScreenSizes;
(function (ScreenSizes) {
    ScreenSizes[ScreenSizes["Mobile"] = 360] = "Mobile";
    ScreenSizes[ScreenSizes["TabletPortrait"] = 768] = "TabletPortrait";
    ScreenSizes[ScreenSizes["Monitor"] = 1366] = "Monitor";
    ScreenSizes[ScreenSizes["Laptop"] = 1280] = "Laptop";
})(ScreenSizes || (ScreenSizes = {}));
export default ScreenSizes;
